import * as React from 'react';
import { FieldsetDataHooks } from './types';
import { classes, st } from './Fieldset.deprecated.st.css';
import { ErrorSmall } from '@wix/wix-ui-icons-common/on-stage';
import { Asterisk } from '../Asterisk/Asterisk';
export const Fieldset = React.forwardRef(({ children, label, errorMessage, labelId, errorMessageId, dataHook, className, showLabelAsterisk, onLabelClick, ...props }, ref) => {
    return (React.createElement("fieldset", { className: st(classes.root, {
            error: Boolean(errorMessage),
        }, className), "data-hook": dataHook, ref: ref, ...props },
        label && (React.createElement("legend", { id: labelId, className: classes.label, onClick: onLabelClick, "data-hook": FieldsetDataHooks.Label },
            label,
            showLabelAsterisk && (React.createElement(Asterisk, { dataHook: FieldsetDataHooks.LabelAsterisk })))),
        children,
        errorMessage && (React.createElement("div", { className: classes.error, id: errorMessageId, "data-hook": FieldsetDataHooks.Error },
            React.createElement(ErrorSmall, { "aria-hidden": true, className: classes.errorIcon }),
            errorMessage))));
});
//# sourceMappingURL=Fieldset.js.map